
import { FloatingLabel, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';


import { DeleteIcon, PencilIcon } from '../assets/icons';
import TooltipHover from './TooltilHover';
import { mesActual } from '../functions/fechaMenos18';
import useContactosEmergencia from '../hooks/useContactosEmergencia';

const ContactosEmergencia = () => {


    const { abrirModal, borrarContacto, cargando, cerrarModal, contactos, formContacto,
            guardarContacto, isOpen, llenarFormContacto, setFormContacto } = useContactosEmergencia();


    return (
        <div className="my-4">
            <hr className='m-5'/>
            <p className="lead text-center">
                Contactos de emergencia
            </p>

            <Button variant="info" onClick={ abrirModal }>
                Agregar contacto
            </Button>

            <div className='table-responsive my-4'>
                <Table bordered hover>
                    <thead>
                        <tr>
                            <th className='text-center'>Nombre</th>
                            <th className='text-center'>Teléfono</th>
                            <th className='text-center'>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        { contactos.map(( e, i )=> (
                            <tr key={ i }>
                                <td className='text-center'>
                                    { e.nombre }
                                </td>
                                <td className='text-center'>
                                    { e.telefono }
                                </td>
                                <td className='text-center'>
                                    <ButtonGroup>
                                        <TooltipHover tooltipText='Editar información'>
                                            <Button variant='warning' onClick={ () => llenarFormContacto( e ) }>
                                                <PencilIcon/>
                                            </Button>
                                        </TooltipHover>
                                        <TooltipHover tooltipText='Eliminar'>
                                            <Button variant='danger' onClick={ () => borrarContacto( e.pk_contacto ) }>
                                                <DeleteIcon/>
                                            </Button>
                                        </TooltipHover>
                                    </ButtonGroup>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>




            <Modal
                show={ isOpen }
                onHide={ cerrarModal }
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className=''
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Administrar registros</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Alert variant='success'>
                        Complete los siguientes campos para guardar su contacto de emergencia.
                    </Alert>

                    <Row>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput31"
                                label="Nombre"
                                className="mb-3"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    max={ mesActual() }
                                    value={ formContacto.nombre }
                                    onChange={ e => setFormContacto({ ...formContacto, nombre: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput32"
                                label="Teléfono"
                                className="mb-3"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    value={ formContacto.telefono }
                                    onChange={ e => setFormContacto({ ...formContacto, telefono: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={ cerrarModal }>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={ guardarContacto } disabled={ cargando }>
                        { ( cargando ) ? "Guardando" : "Guardar cambios" }
                    </Button>
                </Modal.Footer>
                </Modal>
        </div>
    )
}

export default ContactosEmergencia
